import type { JSX } from 'react';
import { useIsFetching, useIsMutating } from '@tanstack/react-query';

// Barra fina (2px) arriba del shell que aparece mientras hay queries
// fetching o mutations pending. Sin actividad → no renderiza nada.
// La animación es CSS (keyframe `loading-bar` en globals.css).
export const GlobalLoadingBar = (): JSX.Element | null => {
  const fetching = useIsFetching();
  const mutating = useIsMutating();
  const active = fetching + mutating;
  if (active === 0) return null;
  return (
    <div
      role="progressbar"
      aria-label="Cargando"
      aria-busy="true"
      className="fixed inset-x-0 top-0 z-60 h-0.5 overflow-hidden"
    >
      <div className="animate-loading-bar bg-primary h-full w-full origin-left" />
    </div>
  );
};
